/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import * as Sentry from "@sentry/browser";
import LogRocket from "logrocket";

require("dotenv").config();
if (process.env.REACT_APP_SENTRY_FRONTEND_DSN)
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_FRONTEND_DSN });
if (process.env.REACT_APP_LOGROCKET_KEY)
  LogRocket.init(process.env.REACT_APP_LOGROCKET_KEY);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
// registerServiceWorker();
